$ = require 'jquery'

module.exports =
class aboutSequence

  constructor: ->
    @$section  = $ '.section-about'
    @$heading  = @$section.find '.heading img'
    @$contents = @$section.find '.contents-container'
    @$text     = @$contents.find '.text'
    @$imgWrap  = @$contents.find '.img-1-inner'
    @$img      = @$imgWrap.find '.clip-circle'

  getInitialVals: =>
    [
      {
        e: [ @$heading, @$imgWrap, @$img ]
        p: { display: 'none' }
      }
      {
        e: @$text
        p: { visibility: 'hidden' }
      }
    ]

  getSequences: =>
    imgY = @$imgWrap.offset().top + @$imgWrap.height()

    {
      first: [
        {
          e: @$heading.eq 0
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', -200 ]
          o: { duration: 300, display: 'block' }
        }
        {
          e: @$heading.eq 1
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', -200 ]
          o: { duration: 300, display: 'block', delay: 200, sequenceQueue: false }
        }
        {
          e: @$heading.eq 2
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', -200 ]
          o: { duration: 300, display: 'block', delay: 200, sequenceQueue: false }
        }
        {
          e: @$text
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', 300 ]
          o: { duration: 300, visibility: 'visible', delay: 200, sequenceQueue: false }
        }
        {
          e: @$imgWrap
          p: { translateY: [ 0, -imgY ] }
          o: { duration: 600, easing: 'easeOutBack', display: 'block', delay: 200, sequenceQueue: false }
        }
        {
          e: @$img
          p: { translateY: [ 0, imgY ] }
          o: { duration: 600, easing: 'easeOutBack', display: 'block', sequenceQueue: false }
        }
      ]
    }



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/anime-sequence/about-sequence.coffee